import {ID, Model, ResponseSerialize} from 'simpli-web-sdk'
import Motorista from '@/model/resource/Motorista'

export default class MotoristaLoteRequest extends Model {
  @ResponseSerialize(Motorista)
  motorista: Motorista | null = null

  @ResponseSerialize(Motorista)
  motoristas: Motorista[] = []

  forcar: boolean | null = null

  naoValidar: boolean | null = null

  viaPainel: boolean | null = null
}
